import { Outlet, useLoaderData } from "react-router-dom";

import Loading from "@/components/layout/loading";
import Resolver from "@/components/resolver";
import Empty from "./empty";
import ProjectsList from "./projects-list";

export default function ListView() {
  const { projects } = useLoaderData();

  return (
    <>
      <Resolver fallback={<Loading />} resolve={projects}>
        {(projects) => (
          <>
            {projects?.items.length ? (
              <ProjectsList projects={projects} />
            ) : (
              <Empty />
            )}
          </>
        )}
      </Resolver>

      <Outlet />
    </>
  );
}
